export default __webpack_public_path__ + "static/media/_DSC0538.1f2cb174.JPG";